var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16471 18.3334C3.70638 18.3334 3.31402 18.1702 2.98763 17.8438C2.66124 17.5174 2.49805 17.1251 2.49805 16.6667V5.00008C2.49805 4.54175 2.66124 4.14939 2.98763 3.823C3.31402 3.49661 3.70638 3.33341 4.16471 3.33341H4.99805V1.66675H6.66471V3.33341H13.3314V1.66675H14.998V3.33341H15.8314C16.2897 3.33341 16.6821 3.49661 17.0085 3.823C17.3349 4.14939 17.498 4.54175 17.498 5.00008V16.6667C17.498 17.1251 17.3349 17.5174 17.0085 17.8438C16.6821 18.1702 16.2897 18.3334 15.8314 18.3334H4.16471ZM4.16471 16.6667H15.8314V8.33341H4.16471V16.6667ZM4.16471 6.66675H15.8314V5.00008H4.16471V6.66675Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendaricon.0e124bb890225a58e37530d3f64a104f.svg";
export { ForwardRef as ReactComponent };